import { FormGroup, FormGroupProps } from "@/ui/cva/FormGroup";
import { FormElementProps } from "@/common/contracts/form.contracts";
import { ReactNode } from "react";

type InputGroupProps = Omit<FormGroupProps<FormElementProps>, "element"> & {
  input: ReactNode | ((props: FormElementProps) => ReactNode);
};

/**
 * Groups label, input and helper component while having an option to pass `valid` and `disabled`
 * props to those components.
 *
 * @deprecated Use `FormGroup` instead.
 */
export const InputGroup = ({ input, ...props }: InputGroupProps) => {
  return <FormGroup element={input} {...props} />;
};
